export default "__VITE_ASSET__B5dG9Cex__"